import { UserPassport } from '../api-client';

const hidePassportData = (passport: UserPassport) => {
  const fullPassport = `${passport.series} ${passport.number}`;
  return fullPassport.replace(/\d{2} \d{4}/g, 'XX XXXX');
};

export default hidePassportData;
